import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { SetVersionDialogData } from './set-version-dialog.data';

@Component({
    selector : 'set-version-dialog',
    template: require('./set-version-dialog.component.html'),
    styles: [require('./set-version-dialog.component.scss')]
})
export class SetVersionDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: SetVersionDialogData) {      
        
        data.selected = data.versions &&  data.versions.length && data.versions[0].id? data.versions[0].id : 0
    }
    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/set-version-dialog/set-version-dialog.component.ts